class Org2OrgConvertHistory {
  constructor(obj = {}) {
    this.id = obj.id;
    this.startdate = obj.startdate;
    this.completedate = obj.completedate;
    this.status = obj.status;
    this.agent = obj.agent;
    this.srcorgname = obj.srcorgname;
    this.srclocname = obj.srclocname;
    this.trgtorgname = obj.trgtorgname;
    this.trgtlocname = obj.trgtlocname;
    this.trgtOrg = obj.trgtOrg;
    this.trgtLoc = obj.trgtLoc;
    this.isdone = obj.isdone;
    this.result = obj.result;
  }

  toPlainObject() {
    let obj = {};
    let keys = Object.keys(this);
    for (let k of keys) {
      switch (k) {
        default:
          obj[k] = this[k];
      }
    }
    return obj;
  }
}

export default Org2OrgConvertHistory;



// WEBPACK FOOTER //
// ./src/model/Org2OrgConvertHistory.js